export default __webpack_public_path__ + "c0287d94d7980053d5047c0ba48c91fd.png";